<template>
  <div class="right-fixed-menu">
    <div class="menu-item service-item">
      <el-tooltip placement="left-start" effect="light" popper-class="modern-popper">
        <div slot="content" class="popper-content">
          <div class="popper-header">
            <i class="el-icon-service"></i>
            <span>在线客服</span>
          </div>
          <div class="qr-section">
            <img :src="require('@/assets/imgs/wxkf.png')" class="qr-code" />
            <p class="qr-tip">扫码添加微信客服</p>
          </div>
          <a href="https://work.weixin.qq.com/kfid/kfc502514268be0b712" target="_blank" class="contact-btn">
            <i class="el-icon-chat-line-round"></i>
            联系客服
          </a>
        </div>
        <div class="menu-link">
          <div class="menu-icon">
            <img :src="require('@/assets/imgs/guest.png')" />
          </div>
          <span>客服</span>
        </div>
      </el-tooltip>
    </div>

    <div class="menu-item">
      <el-tooltip placement="left-start" effect="light" popper-class="modern-popper">
        <div slot="content" class="popper-content">
          <div class="popper-user-info">
            <div class="user-avatar">
              <img :src="require('@/assets/imgs/ucenter.png')" v-if="!userInfo.id" />
              <span v-else>{{ userInfo.username ? '会员' : '用户' }}</span>
            </div>
            <div class="user-greeting">
              {{ userInfo.id ? '您好，' + userInfo.username : '请先登录' }}
            </div>
          </div>
          <div class="quick-actions">
            <div class="action-item" @click="gotoCollect">
              <img :src="require('@/assets/imgs/waiting-pay.png')" />
              <span>商品收藏</span>
            </div>
            <div class="action-item" @click="gotoCollect">
              <img :src="require('@/assets/imgs/waiting-shop.png')" />
              <span>品牌收藏</span>
            </div>
          </div>
          <div class="popper-footer">
            <el-button type="danger" size="medium" round @click="gotoUcenter" class="center-btn">
              <i class="el-icon-user"></i>
              进入会员中心
            </el-button>
          </div>
        </div>
        <div class="menu-link">
          <div class="menu-icon">
            <img :src="require('@/assets/imgs/ucenter.png')" />
          </div>
          <span>会员</span>
        </div>
      </el-tooltip>
    </div>

    <div class="menu-item cart-item" @click="gotoCart">
      <div class="menu-link">
        <div class="menu-icon cart-icon">
          <img :src="require('@/assets/imgs/shopCat1.png')" />
          <span class="cart-badge" v-if="getNum > 0">{{ getNum > 99 ? '99+' : getNum }}</span>
        </div>
        <span>购物车</span>
      </div>
    </div>

    <div class="menu-item">
      <el-tooltip placement="left-start" effect="light" popper-class="modern-popper">
        <div slot="content" class="popper-content popper-message">
          <div class="message-empty">
            <i class="el-icon-bell"></i>
            <p>暂无新消息</p>
          </div>
        </div>
        <div class="menu-link">
          <div class="menu-icon">
            <img :src="require('@/assets/imgs/message.png')" />
          </div>
          <span>消息</span>
        </div>
      </el-tooltip>
    </div>

    <div class="menu-item">
      <el-tooltip placement="left-start" effect="light" popper-class="modern-popper">
        <div slot="content" class="popper-content popper-app">
          <div class="app-header">
            <i class="el-icon-mobile-phone"></i>
            <span>绒博汇APP</span>
          </div>
          <img :src="require('@/assets/imgs/qrcode1.png')" class="app-qr" />
          <p class="app-tip">扫码下载APP</p>
        </div>
        <div class="menu-link">
          <div class="menu-icon">
            <img :src="require('@/assets/imgs/code.png')" />
          </div>
          <span>APP</span>
        </div>
      </el-tooltip>
    </div>

    <div class="menu-item back-top" @click="scrollToTop" id="backTop">
      <div class="menu-link">
        <div class="menu-icon">
          <i class="el-icon-arrow-up"></i>
        </div>
        <span>顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CustomerService",
  data() {
    return {
      userInfo: {},
    };
  },
  computed: {
    ...mapGetters(["getNum"]),
  },
  mounted() {
    this.userInfo = this.$store.getters.getUser;
  },
  methods: {
    /**
     * 进入我的收藏
     */
    gotoCollect() {
      if (!this.userInfo.id) {
        this.$store.dispatch("setShowLogin", true);
        return false;
      }
      this.$router.push("/collect");
    },
    /**
     * 进入会员中心
     */
    gotoUcenter() {
      if (!this.userInfo.id) {
        this.$store.dispatch("setShowLogin", true);
        return false;
      }
      this.$router.push("/ucenter");
    },
    /**
     * 进入购物车
     */
    gotoCart() {
      this.$router.push("/shoppingCart");
    },
    /**
     * 回到顶部
     */
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
/* 右侧悬浮工具栏 */
.right-fixed-menu {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #2d3436 0%, #1a1a2e 100%);
  border-radius: 12px 0 0 12px;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.menu-item {
  position: relative;
  width: 50px;
  padding: 12px 0;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
}

.menu-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
}

.menu-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-icon img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.menu-icon i {
  font-size: 20px;
}

.menu-item span {
  font-size: 10px;
  line-height: 1.2;
}

/* 购物车项 */
.cart-item .menu-link {
  position: relative;
}

.cart-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ff6b6b;
  color: white;
  font-size: 9px;
  padding: 2px 4px;
  border-radius: 10px;
  min-width: 16px;
  text-align: center;
}

/* 回到顶部 */
.back-top {
  margin-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 12px;
}

/* 弹出框内容 */
.popper-content {
  padding: 15px;
  min-width: 200px;
}

.popper-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ff6b6b;
}

.popper-header i {
  color: #ff6b6b;
}

.qr-section {
  text-align: center;
  margin-bottom: 15px;
}

.qr-code {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.qr-tip {
  font-size: 12px;
  color: #666;
}

.contact-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px;
  background: linear-gradient(135deg, #07c160 0%, #06ad56 100%);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.4);
}

/* 用户信息弹出框 */
.popper-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.user-avatar img {
  width: 30px;
  height: 30px;
}

.user-greeting {
  font-size: 14px;
  color: #333;
}

.quick-actions {
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.action-item:hover {
  background: #fff5f5;
}

.action-item img {
  width: 32px;
  height: 32px;
  margin-bottom: 6px;
}

.action-item span {
  font-size: 12px;
  color: #666;
}

.popper-footer {
  text-align: center;
}

.center-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%) !important;
  border: none !important;
  padding: 10px 25px !important;
}

.center-btn i {
  margin-right: 5px;
}

/* 消息弹出框 */
.message-empty {
  text-align: center;
  padding: 20px;
  color: #999;
}

.message-empty i {
  font-size: 40px;
  margin-bottom: 10px;
  display: block;
}

.message-empty p {
  font-size: 14px;
}

/* APP弹出框 */
.popper-app {
  text-align: center;
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.app-header i {
  color: #667eea;
}

.app-qr {
  width: 140px;
  height: 140px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.app-tip {
  font-size: 12px;
  color: #666;
}

/* 悬停效果增强 */
.menu-item:hover .menu-link {
  color: white;
}

.service-item:hover .menu-icon img {
  filter: brightness(10);
}
</style>